import satistics from "../../../data/data-class/homePage/statisticClass";
import ViaqTryCatch from "../../../services/GlobalTryCatch";
import axiosInstance from "../../../services/axios";

export default class StatisticsRepository {
    static async getStatistics(id) {
        const data_pas = {
            currentStatstic: id
        }
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/dashboard", data_pas)
            });

        if (response.success) {
            const data = response.data;
            const statistic = new satistics(
                data.device_connected,
                data.device_active,
                data.device_storehouse,
                data.user_number,
                data.user_owner,
                data.user_subscribed,
                data.financial_total,
                data.financial_device,
                data.financial_subscribe,
                data.new_order,
                data.progress_order,
                data.delivered_order,
                data.panel_massage_inventory,
                data.panel_port_inventory,
                data.panel_settling_inventory
            );
            return {
                statistic: statistic,
                code: response.statusCode,
                massage: response.message,
            };
        }
        return {
            code: response.statusCode,
            massage: response.message,
        };

    }
}
